// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".action-button[data-v-48d10632]{max-width:var(--space-giga)}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/widgets/modal/DeleteModal.vue"],"names":[],"mappings":"AA2CA,gCACE,2BAAA","file":"DeleteModal.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.action-button {\n  max-width: var(--space-giga);\n}\n"]}]);
// Exports
module.exports = exports;
